// extracted by mini-css-extract-plugin
export var button_container = "LatestInsights-module--button_container--CfRnF";
export var latest_insight = "LatestInsights-module--latest_insight--BmewK";
export var latest_insights = "LatestInsights-module--latest_insights--bu81o";
export var latest_insights_container = "LatestInsights-module--latest_insights_container--++KOT";
export var page404Title = "LatestInsights-module--page404-title--18mJ5";
export var seeAllButton = "LatestInsights-module--seeAllButton--O6Glz";